import classNames from "classnames";
import CurrentWeather from "./CurrentWeather";
import WeatherWarning from "./WeatherWarning";
import WeatherForecast from "./WeatherForecast";
import TodayDetail from "./TodayDetail";
import { isShowNews1 } from "@/utils/isShowNews1";
import SunriseSunset from "./SunriseSunset";
import NewsItem from "./NewsItem";
import { useAdCpt1, useAdCpt2 } from "@/hooks/adCpt/homeVendor";
export default function VendorLayout() {
  const adPosition22 = useAdCpt1("position-22");
  const adPosition35 = useAdCpt2("position-35");
  return (
    <div className={classNames(["flex flex-col justify-start gap-y-10 box-border p-[0_16px]"])}>
      <div data-position="position-08">{useAdCpt2("position-08")}</div>
      {/* 当前天气 */}
      <CurrentWeather />
      <div data-position="position-22">{adPosition22}</div>
      {/* 黄色警告 */}
      <WeatherWarning />
      {/* 按小时展示天气+10/15天天气预报 */}
      <WeatherForecast />
      {/* 今日详情 */}
      <TodayDetail />
      {(isShowNews1().validMain || isShowNews1().isIdVls) && <NewsItem />}
      <div data-position="position-35">{adPosition35}</div>
      {/* 日出日落 */}
      <SunriseSunset />
    </div>
  );
}
